"use client";

import React from "react";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import styles from "./footer.default.module.css";
import SalifyLink from "src/lib/components/link/salify-link";
import Grid from "@mui/material/Grid";

export interface VariantProps {
  chip: {
    props: {
      label: string;
      color: string;
      variant: string;
    };
    title: string;
  };
  description?: string;
  aboutUs: Array<{ label: string; url: string }>;
  customerCare: Array<{ label: string; url: string }>;
  contactUs: {
    address: string;
    email: string;
    phone: string;
  };
  socialItems: Array<{ url: string; title: string }>;
  theme: any;
}
const FooterDefault: React.FC<VariantProps> = (props) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            sx={{ display: "flex", flexDirection: "row", padding: "24px", color: "#fff" }}
          >
            <Grid item xs={12} sm={6} lg={4} sx={{ display: "flex", flexDirection: "column" }}>
              <Box mb={1}>
                <Chip {...(props.chip.props as any)} />
                <span className={styles.title}>{props.chip.title}</span>
              </Box>
              <Typography variant="caption" className={styles.title}>
                {props.description}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} lg={2} sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant={"subtitle1"}>About Us</Typography>
              {props.aboutUs.map((item, ind) => (
                <SalifyLink key={`about-${ind}`} className={styles.title} href={item.url}>
                  <Typography variant="caption">{item.label}</Typography>
                </SalifyLink>
              ))}
            </Grid>
            <Grid item xs={12} sm={6} lg={3} sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant={"subtitle1"}>Customer Care</Typography>
              {props.customerCare.map((item, ind) => (
                <SalifyLink key={`customer-care-${ind}`} className={styles.title} href={item.url}>
                  <Typography variant="caption">{item.label}</Typography>
                </SalifyLink>
              ))}
            </Grid>
            <Grid item xs={12} sm={6} lg={3} sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant={"body1"}>Contact Us</Typography>
              <Typography variant="caption" className={styles.title}>
                {props.contactUs.address}
              </Typography>
              <Typography variant="caption" className={styles.title}>
                Email:&nbsp;{props.contactUs.email}
              </Typography>
              <Typography variant="caption" className={styles.title}>
                Phone:&nbsp;{props.contactUs.phone}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </div>
    </footer>
  );
};

FooterDefault.displayName = "FooterDefault";

export default FooterDefault;
